import { css } from "emotion";

export const containerWrapper = css`
  background-image: linear-gradient(125deg,#009496,rgba(0,220,223,.5)),linear-gradient(118deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.69)),linear-gradient(#00b7ba,#00b7ba);
  overflow: hidden;
  @media (max-width: 1200px) {
    padding-bottom: 36px;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const formContainer = css`
  max-width: 1170px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.9fr;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`

export const titleSection = css`
  text-align: center;
  padding-top: 28px;
  padding-bottom: 28px;
  margin: 0;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  letter-spacing: normal;
  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

export const imgWrapper = css`
  max-height: 406px;
  @media (max-width: 1200px) {
    display: none;
  }
`
export const formImg = css`
  margin-bottom: -5px;
`;

export const whiteBoxWrapper = css`
  display: flex;
  align-items: center;
`

export const whiteBox = css`
  width: 100%;
  height: 320px;
  max-width: 767px;
  margin: 0 auto;
  background-color: #fff;
  padding: 28px 30px;
  border-radius: 12px;
  box-shadow: 0 3px 5px 5px rgba(187, 204, 236, 0.35);
  overflow: auto;

  display:flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  & div#res-submit {
    height: auto;
    max-width: 500px;
    padding: 0;
    // margin-top: 14px;
  }

  @media (max-width: 600px) {
    padding: 28px 20px;
    // height: auto;
    // max-height: 320px;
  }
`